import { configureStore } from '@reduxjs/toolkit';
import serviceworkerItemReducer from './ServiceWorkerItemSlice'

const serviceworkerItemStore = configureStore({
  reducer: {
    serviceworkerItems: serviceworkerItemReducer
  }
});

export default serviceworkerItemStore;